<template>
    <div>
        <el-checkbox-group 
            v-model="deleteCheckboxesTemp"
        >
            <el-form :model="fileList" :rules="rules" ref="form">
                <div
                    class="el-upload-list el-upload-list--picture-card"
                    style="display: flex; margin-bottom: 20px"
                    v-for="(item, index) in fileList.files"
                    :key="index"
                >
                    <div class="el-upload-item_list-block" style="display: block">
                        <div class="el-upload-list-item-file">
                            <template v-if="item.type == 'image'">
                                <img :src="item.file.image.currentSrc" alt class="el-upload-list__item-thumbnail" />
                            </template>
                            <div v-else>
                                <i class="el-icon-document"></i>
                            </div>
                            <span class="el-upload-item_list-block-actions">
                                <span class="el-upload-list__item-preview" @click="deleteFile(index)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="el-upload-list_right-form">
                        <el-form-item 
                            :prop="'files.' + index + '.title'"
                            :rules="{ required: true, message: 'Поле не должно быть пустым', trigger: 'blur' }"
                        >
                            <el-input 
                                placeholder="Отображаемое имя файла" 
                                v-model="item.title"
                                @change="documentEditTitle({
                                    title: item.title,
                                    guid: item.fileName,
                                    id: item.id
                                })" 
                            >
                            </el-input>
                        </el-form-item>
                        <span class="m-r-10" v-if="item.file.name">{{ item.file.name }}</span>
                        <a :href="item.file.image.currentSrc" target="_blank" class="downloadFile Info m-r-15">Скачать</a>
                        <el-checkbox v-if="item.fileName" :label="item.fileName">Удалить</el-checkbox>
                        <a v-else @click="deleteFile(index)" class="downloadFile Info m-r-15" style="cursor: pointer;">Удалить</a>
                    </div>
                </div>
            </el-form>
        </el-checkbox-group>
        <el-upload
            class="upload-demo"
            action="#"
            :on-change="beforeupload"
            :multiple="false"
            :show-file-list="false"
            :auto-upload="false"
            :limit="1"
            :file-list="handleExceed"
        >
            <el-button size="small" type="primary" plain>Выбрать файл</el-button>
            <div slot="tip" class="el-upload__tip">Размер файла не должен превышать 2 МБ</div>
        </el-upload>
    </div>
</template>

<script>
export default {
    data() {
        return {
            handleExceed: [],
            deleteCheckboxesTemp: [],
            form: {
                name: '',
                file: null,
            },
            rules: {
				title: [
					{ required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
				]
            }
        }
    },
    props: {
        editNews: {
            type: Boolean,
            default: false
        },
        fileList: {
            type: Object,
            default() {
               return {files: []}
            }
        },
    },
    methods: {
        beforeupload(event, fileList) {
            this.$emit('addFile', {
                title: '',
                file: event
            })
            this.handleExceed = []
        },
        deleteFile(index) {
            this.$emit('removeNewFile', index)
        },
        async validateFilesName() {
            let test 
            await this.$refs.form.validate(async (valid) => {
                test = valid
            })
            return test
        },
        
        async documentEditTitle(data) {

            let dataFile = {
                id: data.id,
                parentId: null,
                title: data.title,
                sorting: null
            }

            if(data.guid) {
                try {
                    await this.$store.dispatch('documentEditFile', dataFile)
                    this.$message({
                        message: 'Файл успешно переименован',
                        type: 'success'
                    });
                } catch(e) {
                    this.$ErrorsMod(e)
                }
            }
        },
    },
    watch: {
        deleteCheckboxesTemp(val) {
            this.$emit('deleteCheck', val)
        }
    }
}
</script>